import ToggleFullscreen from './ToggleFullscreen';

export default ToggleFullscreen;
